import { createStore } from "vuex";

export default createStore({
  state: {
    isLoggedIn: false,
  },
  mutations: {
    setLoggedIn(state, value) {
      state.isLoggedIn = value;
    },
  },
  actions: {
    login({ commit }) {
      // ... Einloggen logik
      commit("setLoggedIn", true);
    },
    logout({ commit }) {
      // ... Ausloggen logik
      commit("setLoggedIn", false);
    },
  },
  getters: {
    isLoggedIn: (state) => state.isLoggedIn,
  },
});
